<template>
    <div v-if="!popup || subscribe" v-bind:class="{ subscribe: true, 'subscribe--popup': popup }">
        <div v-if="popup" class="subscribe__overlay" v-on:click="hideSubscribe()"></div>
        <div class="subscribe__window">
            <div v-if="popup" class="subscribe__close" v-on:click="hideSubscribe()">
                <svg>
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
                </svg>
            </div>
            <div class="subscribe__form">
                <div class="subscribe__icon">
                    <svg>
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-mail"></use>
                    </svg>
                </div>
                <h3 class="subscribe__heading">Åpenhet på e-post</h3>
                <div class="subscribe__text">Skriv deg opp på vår e-post-liste. Da får du nyhetsbrev når det skjer ting på feltene du er interessert i.</div>
                <div class="subscribe__text subscribe__success" v-if="subscribed">Du abonnerer nå på nyhetsbrevet!</div>
                <div class="subscribe__text subscribe__error" v-html="error" v-if="error"></div>
                <input ref="email" type="email" v-model="email" class="subscribe__email" placeholder="Din e-postadresse" />
                <div class="subscribe__groups">
                    <label v-for="(group, index) in groups" v-bind:key="index"> <input type="checkbox" v-model="group.checked" />{{ group.label }} </label>
                </div>
                <button class="subscribe__button" v-on:click="submit">
                    <template v-if="!subscribing">Meld meg på</template>
                    <template v-else>Abonnerer...</template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex';

export default {
    name: 'Subscribe',
    props: {
        popup: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            email: '',

            groups: [
                /**{
                    id: '844197acbe',
                    label: 'Åpenhet i statsgjeld',
                    checked: false,
                },*/
                {
                    id: '844197acbd',
                    label: 'Åpenhet i selskap',
                    checked: false,
                },
                {
                    id: 'bf12830ce2',
                    label: 'Åpenhet i politikk',
                    checked: false,
                },
                {
                    id: '301f197ee6',
                    label: 'Åpenhet i eierskap',
                    checked: false,
                },
            ],

            error: null,
            subscribing: false,
            subscribed: false,
        };
    },
    computed: mapState(['subscribe']),
    methods: {
        ...mapActions(['hideSubscribe']),

        submit: async function () {
            /*eslint no-useless-escape: "off"*/
            const reg =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
            const email = this.email.toLowerCase();

            if (!email) {
                this.error = 'Du må oppgi e-postadressen din.';
                this.$refs.email.focus();
            } else if (!reg.test(email)) {
                this.error = 'Du må oppgi en gyldig e-postadresse.';
                this.$refs.email.focus();
            } else {
                this.error = '';
                if (!this.subscribing) {
                    this.subscribing = true;

                    try {
                        const response = await axios({
                            method: 'post',
                            url: 'https://data.apenhet.no/subscribe.php',
                            data: {
                                email: email,
                                interests: {
                                    '844197acbd': this.groups[0].checked,
                                    bf12830ce2: this.groups[1].checked,
                                    '301f197ee6': this.groups[2].checked,
                                },
                            },
                            headers: {
                                'X-Noop-Subscribe': '7a896c66-3a63-4006-929f-40507ed066ff',
                            },
                        });

                        if (process.env.NODE_ENV == 'development') {
                            console.log(response);
                        }

                        this.subscribing = false;
                        this.subscribed = true;
                        window.setTimeout(() => {
                            this.subscribed = false;
                            if (this.popup) {
                                this.hideSubscribe();
                            }
                        }, 1000);
                    } catch (error) {
                        this.error = 'Det oppstod en feil. Prøv igjen senere.';
                        console.log(error);
                        this.subscribing = false;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/styles/global';

.subscribe {
    display: flex;
    align-items: center;
    justify-content: center;

    &--popup {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
    }

    &__overlay {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;

        background-color: rgba(255, 255, 255, 0.5);
    }

    &__window {
        position: relative;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        background-color: #a2bfdb;

        .subscribe--popup & {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;

            z-index: 100;
            padding: 50px;
            border: solid 1px #3c72bc;

            @include bp($laptop) {
                position: relative;
                left: auto;
                right: auto;
                top: auto;
                bottom: auto;
            }
        }
    }

    &__close {
        top: 20px;
        right: 20px;
        position: absolute;
        color: #fff;
        svg {
            width: 20px;
            height: 20px;
        }
    }

    &__form {
        display: flex;
        flex-direction: column;

        @include bp($laptop) {
            width: 500px;
        }

        .subscribe--popup & {
            width: 100%;

            @include bp($laptop) {
                width: 400px;
            }
        }
    }

    &__icon {
        margin: 15px auto;

        .subscribe--popup & {
            margin-top: 50px;
            margin-bottom: 30px;

            @include bp($laptop) {
                margin-bottom: 15px;
            }
        }

        svg {
            width: 60px;
            height: 35px;
        }
    }

    &__heading {
        margin-bottom: 10px;
        color: #fff;
        text-align: center;
        font-size: 30px;
        line-height: 1;

        @include bp($laptop) {
            margin-bottom: 15px;
            font-size: 45px;
        }
    }

    &__text {
        margin-bottom: 20px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        line-height: 1.3;

        @include bp($laptop) {
            font-size: 18px;

            .subscribe--popup & {
                text-align: left;
            }
        }
    }

    &__success {
        color: darken(#3c72bc, 10%);
        text-align: left;
    }

    &__error {
        color: red;
        text-align: left;
    }

    &__email {
        width: 100%;
        margin-bottom: 20px;
        padding: 10px;
        border: 1px solid #fff;

        font-family: $body-font-famlily;
        font-size: 17px;

        &:focus {
            border-color: #3c72bc;
            outline: none;
        }
    }

    &__groups {
        margin-bottom: 35px;
        // column-count: 2;

        input {
            display: inline-block;
            margin-right: 5px;

            ::placeholder {
                color: #a2bfdb;
            }
            ::-webkit-input-placeholder {
                color: #a2bfdb;
            }
        }
        label {
            display: block;
            margin-bottom: 3px;
            margin-right: 10px;
            font-size: 16px;
            color: #fff;

            cursor: pointer;

            @include bp($laptop) {
                font-size: 18px;
                display: inline-block;
            }

            .subscribe--popup & {
                display: block;
            }
        }
    }

    &__button {
        align-self: center;
        padding: 6px 20px 10px 20px;
        border-width: 0;

        background-color: #3c72bc;
        color: #fff;

        font-family: inherit;
        font-size: 18px;
        font-weight: 300;
        cursor: pointer;

        @include bp($laptop) {
            font-size: 20px;
        }

        &:hover,
        &:focus {
            color: #000;
            background-color: #fff;
        }
    }
}
</style>
